import React, { useState, useEffect } from "react";
import "../navbar.scss";
import Logo from "../img/base/111.png";
import axios from "axios";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavbarText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Label,
  Row,
  Card,
  Spinner,
  Alert,
  CardBody,
} from "reactstrap";
import * as FaIcons from "react-icons/fa";
import { Outlet, useNavigate, Link } from "react-router-dom";
import SidebarPer from "./SidebarPer";
import Swal from "sweetalert2";
import { useAuth } from "../../utils/AuthContext";
import useIdleTimer from "../../utils/useIdleTimer";

const TIMEOUT_DURATION = 10 * 60 * 1000; // 10 minutos en milisegundos

function NavbarBec(args) {
  ////Fecha
  const [nuevaFecha, setNuevaFecha] = React.useState("");
  const [fechaError, setFechaError] = React.useState(false);
  ////
  const [modalContra, setModalContra] = useState(false);
  const abrirCerrarModalContra = () => {
    setModalContra(!modalContra);
  };
  ////FECHA
  const [modalFecha, setModalFecha] = useState(false);
  const abrirCerrarModalFecha = () => {
    setModalFecha(!modalFecha);
  };

  const handleChangefecha = (e) => {
    const value = e.target.value;
    // Validar que la fecha no sea vacía y que sea válida (puedes agregar más validaciones si quieres)
    if (!value) {
      setFechaError(true);
    } else {
      setFechaError(false);
    }
    setNuevaFecha(value);
  };

  // Estado y efectos
  const [fec, setFec] = useState([]);

  // Estado de la lista de comunicados
  const [listaCom, setListaCom] = useState([]);

  // Estado del modal y el comunicado a mostrar
  const [modalCom, setModalCom] = useState(false);
  const [comunicadoMostrado, setComunicadoMostrado] = useState(null);

  // Constantes
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  ///link api php
  const baseUrlP = "https://bqef-bo.com/api/P/apiPer.php";
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";

  /////Listar datos personal administrativo
  const [dataPer, setDataPer] = useState({
    id_per: "",
    nombre: "",
    apellido: "",
    contrasena: "",
    contrasena_lit: "",
    foto: "",
    // otras propiedades si las tienes
  });

  ////Datos usuario Becario
  const peticionGetPer = async () => {
    setLoading(true);
    setError("");
    const PerId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrlP}?action=getinfoPer&id=${PerId}`);
      // console.log("Respuesta API:", res.data); // Añade esto para depuración
      const infoPerArray =
        res.data.InfoPer && Array.isArray(res.data.InfoPer)
          ? res.data.InfoPer
          : [];
      if (infoPerArray.length > 0) {
        setDataPer(infoPerArray[0]);
      } else {
        setDataPer({});
      }
    } catch (error) {
      console.log(error);
      setError("Error al cargar los datos");
      mostrarMensajeError("Error al obtener datos del usuario");
    } finally {
      setLoading(false);
    }
  };

  ////Datos Fecha Entrega
  const peticionGetFecha = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrlP}?action=getinfoFec`);
      const infoFecArray =
        res.data.InfoFec && Array.isArray(res.data.InfoFec)
          ? res.data.InfoFec
          : [];
      // console.log(res.data);
      if (infoFecArray.length > 0) {
        setFec(infoFecArray[0]);
      } else {
        setFec({});
      }
    } catch (error) {
      console.log(error);
      setError("Error al cargar los datos");
      mostrarMensajeError("Error al obtener datos del usuario");
    } finally {
      setLoading(false);
    }
  };

  /////Modificar Fecha Entrega
  const addFecha = async () => {
    if (fechaError || nuevaFecha === "") {
      // No hacer nada o mostrar un mensaje
      return;
    }
    // Aquí envías la nuevaFecha
    const dataToSend = {
      fecha: nuevaFecha,
    };

    try {
      // const response =
      await axios.post(`${baseUrlP}?action=updateFechaPer`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // Manejar respuesta
      setDataPer((prevDataPer) => ({
        ...prevDataPer,
        fecha: nuevaFecha,
      }));
      peticionGetFecha();
      abrirCerrarModalFecha();
      mostrarAlertaFec();
    } catch (error) {
      console.error("Error al guardar la fecha:", error);
    }
  };

  /////Obtener convocatoria
  const getConvocatoria = async () => {
    // setLoading(true);
    // setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];

      // Filtrar solo los archivos de tipo 'convocatoria'
      const convocatorias = receivedData.filter(
        (item) => item.tipo_archivo === "convocatoria",
      );

      // Obtener el último archivo de convocatoria
      const ultimoConvocatoria =
        convocatorias.length > 0
          ? convocatorias[convocatorias.length - 1]
          : null;

      // console.log(ultimoConvocatoria);

      // Si quieres guardar solo el último en el estado
      setLista(ultimoConvocatoria ? [ultimoConvocatoria] : []);
    } catch (error) {
      // setError("Error al cargar los datos");
    } finally {
      // setLoading(false);
    }
  };

  /////Obtener comunicado
  const getComunicado = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];

      // Filtrar solo los archivos de tipo 'convocatoria'
      const comunicados = receivedData.filter(
        (item) => item.tipo_archivo === "comunicado",
      );

      // Obtener el último archivo de convocatoria
      const ultimoComunicado =
        comunicados.length > 0 ? comunicados[comunicados.length - 1] : null;

      // console.log(ultimoConvocatoria);

      // Si quieres guardar solo el último en el estado
      setListaCom(ultimoComunicado ? [ultimoComunicado] : []);
    } catch (error) {
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  /////Modificar Constraseña Becario
  const peticionPutContra = async () => {
    const dataToSend = {
      id_per: dataPer.id_per,
      contrasena: dataPer.contrasena,
      usu_modificacion: dataPer.id_per,
    };

    // console.log("id_per:", dataPer.id_per);
    // console.log("Datos a enviar:", dataToSend);

    try {
      // const response =
      await axios.put(`${baseUrlP}?action=updateContraPer`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("Respuesta del servidor:", response.data);

      // Actualizar el estado dataAdm con la nueva contraseña
      setDataPer((prevDataAdm) => ({
        ...prevDataAdm,
        contrasena: dataPer.contrasena,
      }));
      peticionGetPer();
      abrirCerrarModalContra();
      mostrarAlertaPA();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };
  ////LOGOUT
  ////sesion cierre
  const { isAuthenticated, logoutSubmit } = useAuth();
  const [remainingTime, setRemainingTime] = useState(TIMEOUT_DURATION);

  // Configurar el temporizador de inactividad
  useIdleTimer(TIMEOUT_DURATION, logoutSubmit, setRemainingTime);

  // Iniciar el temporizador solo si el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      setRemainingTime(TIMEOUT_DURATION); // Reiniciar el tiempo restante
    } else {
      setRemainingTime(TIMEOUT_DURATION); // Reiniciar el tiempo si el usuario no está autenticado
    }
  }, [isAuthenticated]);

  // Función para formatear el tiempo restante en minutos y segundos
  const formatTime = (time) => {
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((time % (1000 * 60)) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  //
  const navigate = useNavigate();
  // LOGOUT
  const logoutSub = () => {
    // Mostrar alerta de confirmación
    Swal.fire({
      title: "¿Está seguro?",
      text: "¿Desea cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, cerrar sesión!",
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.clear(); // Limpia la sesión
        logoutSubmit(); // Actualiza el estado de autenticación
        navigate("/"); // Redirige a la página de inicio
      }
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  ////
  useEffect(() => {
    peticionGetPer();
    peticionGetFecha();
    getConvocatoria();
    getComunicado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // También, cuando listaCom cambie, asignar el primero para mostrar
  useEffect(() => {
    if (listaCom.length > 0) {
      setComunicadoMostrado(listaCom[0]);
    } else {
      setComunicadoMostrado(null);
    }
  }, [listaCom]);

  ////Mostrar comunicados
  const [lista, setLista] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  ////Descargar PDF
  const handleDescargarPdf = async () => {
    var link = document.createElement("a");
    link.setAttribute(
      "href",
      "data:application/pdf;base64," + selectedItem.archivo_com,
    );
    link.setAttribute("download", selectedItem.nom_doc);
    link.click();
  };

  ////ALERTAS
  const mostrarMensajeError = (mensaje) => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: mensaje,
      timer: 5000, // cerrar automáticamente el mensaje de error después de 5 segundos
    });
  };
  const mostrarAlertaFec = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Fecha Actualizada.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaPA = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Constraseña Actualizada",
      timer: 5000,
      icon: "success",
    });
  };
  ////
  const handleSelectItem = (item) => {
    setSelectedItem(item);
  };
  ////Boton Cerrar
  const closeBtn = () => {
    setSelectedItem(null);
  };
  // Función para abrir el modal desde el alert
  const [alertVisible2, setAlertVisible] = useState(true);
  const onDismiss2 = () => setAlertVisible(false);
  const abrirModalDesdeAlert = () => {
    setModalCom(!modalCom);
  };
  ////Modal VER MANUAL PERSONAL
  const [modalVerManual, setModalVerManual] = useState(false);
  const abrirCerrarModalVerManual = () => {
    setModalVerManual(!modalVerManual);
  };

  ///pdf ver manual
  const handleDownloadPdf = () => {
    const link = document.createElement("a");
    link.href = require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO PERSONAL.pdf");
    link.download = "MANUAL USUARIO PERSONAL.pdf";
    link.click();
  };
  // Definir un objeto de validación para contraseña
  const validation = {
    contrasena: {
      regex:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&%"*#¡¿])[A-Za-z\d@$!%?&%"*#¡¿]{8,}$/,
      isValid: true,
    },
  };

  const [isValid, setIsValid] = useState({
    contrasena: false,
  });
  ///
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataPer((prevState) => ({ ...prevState, [name]: value }));

    const isValidValue = validation[name].regex.test(value);
    setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div>
      <Navbar expand="md" {...args}>
        <SidebarPer />
        <Nav>
          <Link to="/Personal/Personal" className="text-light">
            <img
              src={Logo}
              alt="logo"
              className="me-2"
              style={{
                height: 60,
                width: 120,
              }}
            />
          </Link>
        </Nav>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            <NavbarText className="text-light">
              {/* Mostrar el temporizador de inactividad solo si el usuario está autenticado */}
              {isAuthenticated && (
                <div>Cierre de sesión en: {formatTime(remainingTime)}</div>
              )}
            </NavbarText>
            <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
            {/* //REVISAR */}
            <NavbarText className="text-light">
              {dataPer.nombre} {dataPer.apellido}
            </NavbarText>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="text-light">
                MENU
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem onClick={() => abrirCerrarModalVerManual()}>
                  Instrucciones
                </DropdownItem>
                {lista.map((item) => (
                  <DropdownItem
                    key={item.id_com}
                    onClick={() => handleSelectItem(item)}
                  >
                    Postulacion
                  </DropdownItem>
                ))}
                <DropdownItem onClick={() => abrirCerrarModalFecha()}>
                  Fecha Entrega
                </DropdownItem>
                <DropdownItem href="http://www.bqef.org/" target="_blank">
                  Sobre Nosotros...
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => abrirCerrarModalContra()}>
                  Cambiar Contraseña
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={logoutSub}>Salir</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
      <Alert
        color="info"
        isOpen={alertVisible2}
        toggle={onDismiss2}
        style={{
          maxWidth: "80vw",
          position: "absolute",
          top: "70%",
          right: "0%",
          transform: "translate(-50%, -50%)",
          animation: "slideIn 1s forwards",
          zIndex: 1000,
        }}
      >
        <span
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={abrirModalDesdeAlert}
        >
          <FaIcons.FaCommentAlt />
          &nbsp; Comunicado &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </Alert>

      {/* MODAL CONTRASEÑA */}
      <Modal isOpen={modalContra} toggle={abrirCerrarModalContra}>
        <ModalHeader className="header_mo">Editar Contraseña</ModalHeader>
        <ModalBody>
          <Label>Clave Actual:</Label>
          <Input
            disabled
            type="text"
            className="form-control"
            value={dataPer.contrasena_lit || "No disponible"}
          />
          <Label>Nueva Clave: </Label>
          <Input
            type="text"
            className="form-control"
            name="contrasena"
            onChange={handleChange}
          />
          {!isValid.contrasena && (
            <span style={{ color: "red" }}>
              La contraseña debe tener al menos 8 caracteres, incluyendo
              mayúsculas, minúsculas, números y caracteres especiales
            </span>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            size="lg"
            onClick={() => peticionPutContra()}
            disabled={!isValid.contrasena}
          >
            Guardar
          </Button>
          {"   "}
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalContra()}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* MODAL FECHA */}
      <Modal isOpen={modalFecha} toggle={abrirCerrarModalFecha}>
        <ModalHeader className="header_mo">
          Establecer Fecha Entrega
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <Label>Fecha Establecida: </Label>
            <h2 className="text-center">"{fec.fecha}"</h2>
            <Label>Nueva Fecha: </Label>
            <br />
            <Input
              type="date"
              className="form-control"
              name="fecha"
              value={nuevaFecha}
              onChange={handleChangefecha}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" size="lg" onClick={addFecha}>
            Guardar
          </Button>
          {fechaError && (
            <span style={{ color: "red" }}>
              Please select a valid date and time before saving
            </span>
          )}
          {"   "}
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalFecha()}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal VER MANUAL PERSONAL*/}
      <Modal
        isOpen={modalVerManual}
        toggle={abrirCerrarModalVerManual}
        size="xl"
      >
        <ModalHeader className="header_mo">
          Manual Usuario Personal Administrativo
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody className="p-0">
              <Row className="justify-content-center">
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "500px",
                  }}
                >
                  <object
                    data={require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO PERSONAL.pdf")}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                  >
                    <p>
                      Este navegador no soporta PDFs. Por favor,
                      <a
                        href={require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO PERSONAL.pdf")}
                      >
                        {" "}
                        descarga el PDF
                      </a>{" "}
                      para verlo.
                    </p>
                  </object>
                </div>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ float: "right" }}
            color="success"
            size="lg"
            onClick={handleDownloadPdf}
          >
            <FaIcons.FaDownload />
            Descargar
          </Button>
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalVerManual()}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {/* Modal para mostrar el comunicado */}
      <Modal isOpen={modalCom} toggle={abrirModalDesdeAlert} size="xl">
        {comunicadoMostrado && (
          <>
            <ModalHeader className="header_mo">
              {comunicadoMostrado.nom_doc}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody className="p-0">
                  <Row className="justify-content-center">
                    <object
                      data={
                        "data:application/pdf;base64," +
                        comunicadoMostrado.archivo_com
                      }
                      type="application/pdf"
                      width="100%"
                      height="600"
                    >
                      <p>
                        Tu navegador no puede mostrar este archivo PDF. Puedes
                        descargarlo{" "}
                        <a
                          href={
                            "data:application/pdf;base64," +
                            comunicadoMostrado.archivo_com
                          }
                          download={comunicadoMostrado.nom_doc}
                        >
                          aquí
                        </a>
                        .
                      </p>
                    </object>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                size="lg"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href =
                    "data:application/pdf;base64," +
                    comunicadoMostrado.archivo_com;
                  link.download = comunicadoMostrado.nom_doc;
                  link.click();
                }}
              >
                <FaIcons.FaDownload /> Descargar
              </Button>
              <Button
                color="danger"
                size="lg"
                onClick={() => abrirModalDesdeAlert()}
              >
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </Modal>
      {/* Modal VER CONVOCATORIA */}
      <Modal isOpen={selectedItem !== null} toggle={closeBtn} size="xl">
        {selectedItem && (
          <>
            <ModalHeader className="header_mo">
              {selectedItem.nom_doc}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody className="p-0">
                  <Row className="justify-content-center">
                    <object
                      data={
                        "data:application/pdf;base64," +
                        selectedItem.archivo_com
                      }
                      type="application/pdf"
                      alt="archivo_per"
                      width="400"
                      height="600"
                    >
                      <p>
                        Tu navegador no puede mostrar este archivo PDF. Puedes
                        descargarlo
                        <a
                          href={
                            "data:application/pdf;base64," +
                            selectedItem.archivo_com
                          }
                          download
                        >
                          aquí
                        </a>
                        .
                      </p>
                    </object>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button
                style={{ float: "right" }}
                color="success"
                size="lg"
                onClick={handleDescargarPdf}
              >
                <FaIcons.FaDownload />
                Descargar
              </Button>
              <Button color="danger" size="lg" onClick={() => closeBtn()}>
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </Modal>
      <Outlet />
    </div>
  );
}

export default NavbarBec;
